// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"4b60a43d","232":"cc9d8a87","237":"bfdf71e4","357":"533f2b99","496":"ab200a7c","526":"8d35bf3f","872":"581c821f"}[chunkId] + ".chunk.js";
};